<template>
    <div class="tw-relative" style="height: 34px">
        <date-range-picker
        v-model="currentRange" 
        v-bind="inputProps"
        :linked-calendars="false"
        :show-dropdowns="true"
        :locale-data="{ format: 'mm/dd/yy' }"
        @update="update"
        class="tw-w-full"
        />

        <div class="tw-absolute tw-z-10 tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-2">
            <i class="fa fa-times tw-cursor-pointer" @click="clear"></i>
        </div>

        <input type="hidden" :name="startDateName" :value="formattedRange.startDate">
        <input type="hidden" :name="endDateName" :value="formattedRange.endDate">
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import { format } from 'date-fns';

export default {
    name: "DateRange",

    components: { DateRangePicker },

    props: {
        initial: {
            type: Object,
            default: function() {
                return {
                    startDate: null,
                    endDate: null
                }
            }
        },
        startDateName: {
            type: String,
            default: "startDate"
        },
        endDateName: {
            type: String,
            default: "endDate"
        },
        inputProps: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },

    data() {
        return {
            // The Date Range Picker prefers the range props to be Date objects
            currentRange: {
                startDate: this.initial.startDate ? new Date(this.initial.startDate) : null,
                endDate: this.initial.endDate ? new Date(this.initial.endDate) : null
            }
        }
    },

    computed: {
        formattedRange() {
            return {
                startDate: this.currentRange.startDate ? format(this.currentRange.startDate, 'yyyy-MM-dd') : null,
                endDate: this.currentRange.endDate ? format(this.currentRange.endDate, 'yyyy-MM-dd') : null
            }
        }
    },

    methods: {
        clear() {
            this.currentRange = {
                startDate: null,
                endDate: null
            };

            this.update();
        },

        update() {
            this.$emit('input', this.formattedRange);
        },
    }
}
</script>